import React, { useContext } from "react";
import { Row, Col } from "react-grid-system";
import { Link } from "gatsby";
import ExternalLink from "../external-link";
import { useSiteMetadata } from "../../hooks/use-site-metadata";

import purdueLogo from "../../images/logos/logo-purdue.png";
import twitter from "../../images/logos/logo-twitter.png";

const PatientFooter = () => {
    const { externalLinkInfo } = useSiteMetadata();
    const { dailymedLinkInfo } = useSiteMetadata();
    return (
        <div className="centered-content">
            <div className="footer-wrapper">
                <Row>
                    <Col lg={3} md={12}>
                        <ul>
                            <li>
                                <a
                                    href="https://www.purduepharma.com/"
                                    target="_blank"
                                >
                                    PurduePharma.com
                                </a>
                            </li>
                            <li>
                                <ExternalLink
                                    externalURL="https://dailymed.nlm.nih.gov/dailymed/fda/fdaDrugXsl.cfm?setid=b7d23ac2-e776-9f62-3290-c64c2d6eb353&type=display"
                                    messageTitle={dailymedLinkInfo.TITLE}
                                    messageBody={externalLinkInfo.BODY}
                                    classNameLink={
                                        externalLinkInfo.LINK_CLASS_NAME
                                    }
                                    classNameOverlay={
                                        externalLinkInfo.OVERLAY_CLASS_NAME
                                    }
                                >
                                    Full Prescribing Information
                                </ExternalLink>
                            </li>
                            <li>
                                <a
                                    href="https://www.purduepharma.com/healthcare-professionals/ask-purdue-medical/"
                                    target="_blank"
                                >
                                    Report a Side Effect
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.purduepharma.com/healthcare-professionals/ask-purdue-medical/"
                                    target="_blank"
                                >
                                    Product Quality Complaint
                                </a>
                            </li>
                        </ul>
                    </Col>
                    <Col lg={3} md={12}>
                        <ul>
                            <li>
                                <Link to="/contact-us">Contact Us</Link>
                            </li>
                            <li>
                                <Link to="/terms-and-conditions">
                                    Terms of Use
                                </Link>
                            </li>
                            <li>
                                <a
                                    href="https://www.purduepharma.com/about/ethics-and-compliance/ccpa/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <Link to="/site-map">Site Map</Link>
                            </li>
                            <li>
                                <a
                                    id="clarip-do-not-sell-link"
                                    rel="noopener noreferrer"
                                >
                                    Do Not Sell My Information
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.purduepharma.com/wp-content/uploads/2023/06/ColoradoDisclosure-Purdue-MR08342.pdf"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    Information for Colorado Prescribers
                                </a>
                            </li>
                        </ul>
                    </Col>
                    <Col lg={6} md={12} order={{ xs: 2, lg: 1 }}>
                        <div className="footer-right-content">
                            <a
                                href="https://www.purduepharma.com/"
                                target="_blank"
                            >
                                <img
                                    src={purdueLogo}
                                    alt="Purdue Logo"
                                    className="footer-purdue-logo"
                                />
                            </a>
                            <p className="no-spacer">
                                &copy;2024 Purdue Pharma L.P., Stamford, CT
                                06901-3431. Intended for residents of the United
                                States only. Purdue, as used in this site,
                                refers to Purdue Pharma L.P., a company in a
                                network of independent associated companies.
                            </p>
                            <p>MR-08616 10/2024</p>
                        </div>
                    </Col>
                    <Col xs={2} order={{ xs: 1, lg: 2 }}>
                        <ExternalLink
                            externalURL="https://twitter.com/purduepharma"
                            messageTitle={externalLinkInfo.TITLE}
                            messageBody={externalLinkInfo.BODY}
                            classNameLink={externalLinkInfo.LINK_CLASS_NAME}
                            classNameOverlay={
                                externalLinkInfo.OVERLAY_CLASS_NAME
                            }
                        >
                            <img
                                className="icon-twitter-footer"
                                src={twitter}
                                alt="@PurduePharma"
                            />
                        </ExternalLink>
                        .
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default function Footer({ indication, ...props }) {
    return (
        <footer {...props}>
            <PatientFooter />
            {/* {indication === 'hcp' && <HcpFooter />}
			{indication === 'patient' && <PatientFooter />} */}
        </footer>
    );
}

Footer.propTypes = {};
